import { render, staticRenderFns } from "./saveMerchantDialog.vue?vue&type=template&id=1f926d25"
import script from "./saveMerchantDialog.vue?vue&type=script&lang=js"
export * from "./saveMerchantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports